.uxn-notification-bell {
	position: relative;

	//TODO temp solution until https://gitlab.com/TRUMPF-corp/trumpf-ux/features/com.trumpf.ux.ui-core/-/issues/42
	.indicator {
		cursor: pointer;
		user-select: none;
		position: absolute;
		top: 2px;
		left: -2px;
		font-size: 8px;
		text-shadow:
			-1px -1px 0 white,
			1px -1px 0 white,
			-1px 1px 0 white,
			1px 1px 0 white;
	}
}
